import { NO, UIAutocompleteDropdownView, UIAutocompleteItem, UIAutocompleteRowView, UIColor } from "uicore-ts"
import { RHAutocompleteRowView } from "./RHAutocompleteRowView"
import { RHColor } from "./RHColor"


export class RHAutocompleteDropdownView<T> extends UIAutocompleteDropdownView<T> {

    displayLabelForItem?: (item: UIAutocompleteItem<T>) => string

    constructor(elementID?: string) {

        super(elementID);

        (this as RHAutocompleteDropdownView<T>).configureWithObject({
            _rowHeight : 38,
            backgroundColor: RHColor.textWhite,
            style: {
                border: `1px solid ${RHColor.borderLight.stringValue}`,
                borderRadius: "0.25rem",
                boxShadow: "0 6px 12px rgba(0, 0, 0, 0.175)",
                overflow: "hidden"
            }
        })

        this.tableView.backgroundColor = UIColor.whiteColor

    }


    override newRowView(identifier: string, rowIndex: number): UIAutocompleteRowView<T> {
        return new RHAutocompleteRowView<T>(
            this.elementID + identifier + rowIndex
        ).configuredWithObject({
            stopsPointerEventPropagation: NO,
            displayLabelForItem: item => {
                if (this.displayLabelForItem) {
                    return this.displayLabelForItem(item)
                }
                return item.label
            }
        })
    }


    refreshVisibleRows() {
        this.tableView.reloadData()
    }


}
